import { html, type TemplateResult } from "lit";
import liveryUrl from "./livery.webp";
// Figma 421:348 / 421:347 / 421:346 — the white-background doodlegrams.
import doodle6 from "./doodle-6.webp";
import doodle9 from "./doodle-9.webp";
import doodle13 from "./doodle-13.webp";

import "./sweepstakes.scss";

const HEADLINE =
  "On October 11, 2026, The No. 24 Hendrick Motorsports Chevrolet, driven by William Byron, " +
  "will sport a paint scheme designed by Palmer Goforth, a 12-year-old blood cancer survivor.";

const INVITE = "Valvoline™ Global invites you to make a difference and donate.";

/** Each doodlegram keeps its own Figma box — one shared size would distort them. */
const DOODLES = [
  { src: doodle6, w: 66, h: 61 },
  { src: doodle9, w: 49, h: 74 },
  { src: doodle13, w: 70, h: 66 },
] as const;

export interface SweepstakesProps {
  /** Overrides the bundled livery photo. */
  readonly livery: string;
}

/**
 * The car reveal. Figma desktop puts the livery (421:356, 745x466) left and the
 * copy (421:344) right; this renders them the other way round — a deliberate
 * change made on 2026-08-13, not a mismatch with the file. Mobile stacks them
 * (428:1036 -> 428:831 -> 428:830), so the copy now leads there too.
 */
export function renderSweepstakes({ livery }: SweepstakesProps): TemplateResult {
  return html`
    <section class="valvoline-sweepstakes">
      <div class="valvoline-sweepstakes__inner">
        <!--
          Copy first, media second — swapped from the Figma order on 2026-08-13.
          Done here rather than with row-reverse or the order property, so the
          reading and tab order match what is on screen: a CSS-only swap leaves
          a screen reader announcing these two the other way round from how they
          look.
        -->
        <div class="valvoline-sweepstakes__copy">
          <p class="valvoline-sweepstakes__headline">${HEADLINE}</p>
          <p class="valvoline-sweepstakes__invite">${INVITE}</p>

          <ul class="valvoline-sweepstakes__doodles">
            ${DOODLES.map(
              (doodle) => html`
                <li
                  class="valvoline-sweepstakes__doodle"
                  style="--vv-w:${doodle.w};--vv-h:${doodle.h}"
                >
                  <img src=${doodle.src} alt="" aria-hidden="true" />
                </li>
              `,
            )}
          </ul>
        </div>

        <div class="valvoline-sweepstakes__media">
          <img
            class="valvoline-sweepstakes__livery"
            src=${livery || liveryUrl}
            alt="The No. 24 Hendrick Motorsports Chevrolet in Palmer Goforth's paint scheme"
          />
        </div>
      </div>
    </section>
  `;
}
